/** @format */

import { z } from "zod";

/**
 * Schema for PDF file upload validation
 */
export const pdfFileSchema = z
  .instanceof(File, { message: "Please select a file" })
  .refine(file => file.size > 0, "File cannot be empty")
  .refine(file => file.size <= 10 * 1024 * 1024, "File size must be less than 10MB")
  .refine(
    file => file.type === "application/pdf" || file.name.toLowerCase().endsWith(".pdf"),
    "File must be a PDF"
  );

export const pdfFileFormSchema = z.object({
  file: pdfFileSchema,
});

export type PdfFileFormData = z.infer<typeof pdfFileFormSchema>;
